import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Table, Thead, Th, Tr, Td } from 'reactable';
import { FormattedDate } from 'react-intl';
import { formatMoney } from 'accounting';
import { isUndefined } from 'lodash';

const formatPaymentDetails = (details) => {
  const provider = details.preferred;
  const account = details[provider];
  let entry = {};
  if (provider.toUpperCase() === 'BANK' && account.country === 'US') {
    entry = {
      bank: 'US BANK ACCOUNT',
      source: account.accountNumber,
      holderName: account.holderName,
    };
  } else if (provider.toUpperCase() === 'BANK' && !isUndefined(account.country)) {
    entry = {
      bank: 'BANK ACCOUNT',
      source: account.iban,
      holderName: account.holderName,
    };
  } else if (provider.toUpperCase() === 'IBAN') {
    entry = {
      bank: 'BANK ACCOUNT',
      source: details.iban,
    };
  } else {
    entry = {
      bank: 'PAYPAL',
      source: details.paypal,
    };
  }
  return entry;
};

export default class AdminWithdrawalsList extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    withdrawals: PropTypes.object.isRequired,
  };

  requestedAmount(withdrawal) {
    const amount = withdrawal.withdrawalAmount;

    return amount ? formatMoney(amount) : null;
  }

  paymentDetailsError() {
    const error = 'Provider and account not provided.';

    return (
      <ul>
        <li display="none">
          { error }
        </li>
      </ul>
    );
  }

  partnerPaymentDetails(details) {
    const provider = details.preferred;
    const account = details[provider];

    if (provider === undefined || account === undefined) {
      return this.paymentDetailsError();
    }
    const data = formatPaymentDetails(details);
    return (
      <ul>
        <li display="none">
          { data.bank }
        </li>
        <li display="none">
          { data.holderName ? data.holderName : ''}
        </li>
        <li display="none">
          { data.source }
        </li>
      </ul>
    );
  }

  partnerLink(w) {
    const partnerPath = `/admin/partners/${w.partnerId}`;

    return (
      <a target="_blank" rel="noopener noreferrer" href={ partnerPath }>
        #{ w.partnerId }
      </a>
    );
  }

  formatDate(date) {
    return (
      <FormattedDate
        value={date}
        day="numeric"
        month="long"
        year="numeric"
        hour="2-digit"
        minute="numeric"
      />
    );
  }

  render() {
  //  const { query, pathname } = this.props.location;

    return (
      <div>
        <Table className="table">
          <Thead>
            <Th column="id">#Id</Th>
            <Th column="createdAt">Date</Th>
            <Th column="partnerName">Partner</Th>
            <Th column="amount">Amount</Th>
            <Th column="paymentDetails">Payment Details</Th>
            <Th column="cdblNotified">Cdbl Emailed</Th>
          </Thead>
          {this.props.withdrawals.valueSeq().map(withdrawal => {
            const w = withdrawal.toJS();
            return (
              <Tr key={ `withdrawal-${w.id}` }>
                <Th column="createdAt">
                  {this.formatDate(w.createdAt) }
                </Th>

                <Td column="id" className="td--primary">{ w.id }</Td>

                <Th column="partnerName">
                  { this.partnerLink(w) }
                </Th>

                <Td column="amount" value={w.withdrawalAmount} className="td--primary">
                  { this.requestedAmount(w) }
                </Td>

                <Th column="paymentDetails" className="td--primary">
                  { this.partnerPaymentDetails(w.paymentDetails) }
                </Th>

                <Th column="cdblNotified">
                  { w.cdblNotified ? 'Yes' : 'No' }
                </Th>
              </Tr>
            );
          })}
        </Table>
      </div>
    );
  }
}
